import { ScreenProps } from '@components-common/types';
import { mapToolbar } from './toolbar';
import { ConfigElement } from '@components-fabric/types';
import { mapForm } from './form';
import { mapView } from './view';

export const mapCreateScreen = (
  config: ConfigElement,
  context: ScreenProps
) => {
  context.type = 'create';
  const result = {
    type: 'create',
    view: {
      ...mapView(config, context),
      ...{
        props: {
          toolbar: mapToolbar(config, context),
          form: mapForm(config as any, context),
        },
      },
    },
  };
  return result;
};
